"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBackgroundCheckStatusDto = instanceOfBackgroundCheckStatusDto;
exports.BackgroundCheckStatusDtoFromJSON = BackgroundCheckStatusDtoFromJSON;
exports.BackgroundCheckStatusDtoFromJSONTyped = BackgroundCheckStatusDtoFromJSONTyped;
exports.BackgroundCheckStatusDtoToJSON = BackgroundCheckStatusDtoToJSON;
exports.BackgroundCheckStatusDtoToJSONTyped = BackgroundCheckStatusDtoToJSONTyped;
const BackgroundCheckStatus_1 = require("./BackgroundCheckStatus");
/**
 * Check if a given object implements the BackgroundCheckStatusDto interface.
 */
function instanceOfBackgroundCheckStatusDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('packageName' in value) || value['packageName'] === undefined)
        return false;
    return true;
}
function BackgroundCheckStatusDtoFromJSON(json) {
    return BackgroundCheckStatusDtoFromJSONTyped(json, false);
}
function BackgroundCheckStatusDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': (0, BackgroundCheckStatus_1.BackgroundCheckStatusFromJSON)(json['status']),
        'packageName': json['packageName'],
    };
}
function BackgroundCheckStatusDtoToJSON(json) {
    return BackgroundCheckStatusDtoToJSONTyped(json, false);
}
function BackgroundCheckStatusDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': (0, BackgroundCheckStatus_1.BackgroundCheckStatusToJSON)(value['status']),
        'packageName': value['packageName'],
    };
}
//# sourceMappingURL=BackgroundCheckStatusDto.js.map